(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-coupons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const feedbackTimers = new WeakMap();

    const copyWithSelection = code => {
      const field = document.createElement('textarea');
      const previousFocus = document.activeElement;
      field.value = code;
      field.readOnly = true;
      field.style.position = 'fixed';
      field.style.top = '0';
      field.style.left = '-9999px';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.focus({ preventScroll: true });
      field.select();
      field.setSelectionRange(0, field.value.length);
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      field.remove();
      if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
      return copied;
    };

    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-holiday-copy]');
      if (!button) return;
      const code = button.dataset.code;
      if (!code) return;

      let copied = copyWithSelection(code);
      if (!copied && navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          copied = false;
        }
      }

      const card = button.closest('.holiday-coupon');
      const feedback = card.querySelector('[data-holiday-copy-feedback]');
      const oldTimer = feedbackTimers.get(button);
      if (oldTimer) window.clearTimeout(oldTimer);
      if (copied) {
        button.classList.add('is-copied');
        button.setAttribute('aria-label', `Coupon code ${code} copied`);
        feedback.textContent = 'Copied!';
      } else {
        button.classList.remove('is-copied');
        const codeText = card.querySelector('.holiday-coupon__code');
        const range = document.createRange();
        range.selectNodeContents(codeText);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        button.setAttribute('aria-label', 'Unable to copy coupon code');
        feedback.textContent = 'Copy failed; code selected';
      }
      feedbackTimers.set(button, window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', `Copy coupon code ${code}`);
        feedback.textContent = '';
      }, 2500));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const summary = event.target.closest('.holiday-faq__question');
    if (!summary) return;
    const item = summary.closest('.holiday-faq__item');
    if (!item) return;
    event.preventDefault();

    const opening = item.dataset.expanded === undefined ? !item.open : item.dataset.expanded !== 'true';
    if (!item.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      item.open = opening;
      delete item.dataset.expanded;
      return;
    }

    const startHeight = item.getBoundingClientRect().height;
    if (item._faqAnimation) {
      item._faqAnimation.onfinish = null;
      item._faqAnimation.cancel();
    }

    item.style.height = 'auto';
    item.open = opening;
    const endHeight = item.getBoundingClientRect().height;
    item.open = true;
    item.style.height = `${startHeight}px`;
    item.dataset.expanded = String(opening);

    const animation = item.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 320, easing: 'ease-in-out' }
    );
    item._faqAnimation = animation;
    animation.onfinish = () => {
      item.open = opening;
      item.style.height = '';
      delete item.dataset.expanded;
      item._faqAnimation = null;
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-influencer-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = root => {
      const stats = root.querySelector('[data-holiday-influencer-stats]');
      if (!stats || stats.dataset.initialized === 'true') return;
      stats.dataset.initialized = 'true';

      const counters = [...stats.querySelectorAll('[data-holiday-count]')].map(element => {
        const original = element.textContent.trim();
        return { element, target: Number(original.replace(/[^0-9]/g, '')), suffix: original.endsWith('+') ? '+' : '' };
      });
      if (!counters.length || counters.some(counter => !Number.isFinite(counter.target))) return;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      counters.forEach(({ element, suffix }) => { element.textContent = `0${suffix}`; });
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const start = performance.now();
        const duration = 1800;
        const tick = now => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          counters.forEach(({ element, target, suffix }) => {
            element.textContent = `${Math.floor(target * eased).toLocaleString('en-US')}${suffix}`;
          });
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.35 });
      observer.observe(stats);
    };

    const initializeAll = scope => {
      if (scope.matches?.('.holiday-influencers')) initialize(scope);
      scope.querySelectorAll('.holiday-influencers').forEach(initialize);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let scheduled = false;
    let pendingNavigation = null;

    const activate = (bar, selected) => {
      bar.querySelectorAll('[data-holiday-sale-nav-item]').forEach(item => {
        const active = item === selected;
        item.closest('.holiday-sale-navigation__item').classList.toggle('is-active', active);
        if (item.tagName === 'BUTTON') item.setAttribute('aria-pressed', String(active));
        else if (active) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
      const list = bar.querySelector('.holiday-sale-navigation__items');
      const listBounds = list.getBoundingClientRect();
      const selectedBounds = selected.getBoundingClientRect();
      if (selectedBounds.left < listBounds.left) list.scrollBy({ left: selectedBounds.left - listBounds.left - 12, behavior: 'smooth' });
      if (selectedBounds.right > listBounds.right) list.scrollBy({ left: selectedBounds.right - listBounds.right + 12, behavior: 'smooth' });
    };

    const headerBottom = () => {
      let bottom = 0;
      document.querySelectorAll('.hdt-section-header, .section-header-navigation, .section-header-mobile').forEach(header => {
        const style = window.getComputedStyle(header);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        const bounds = header.getBoundingClientRect();
        if (bounds.height > 0) bottom = Math.max(bottom, bounds.bottom);
      });
      return Math.max(0, bottom);
    };

    const update = () => {
      scheduled = false;
      const bottom = headerBottom();
      document.querySelectorAll('[data-holiday-sale-navigation]').forEach(section => {
        const slot = section.querySelector('.holiday-sale-navigation__slot');
        const bar = section.querySelector('[data-holiday-sale-navigation-bar]');
        if (!slot || !bar) return;
        bar.style.setProperty('--holiday-sale-navigation-header-bottom', `${bottom}px`);
        bar.classList.toggle('is-fixed', slot.getBoundingClientRect().top <= bottom + 12);
        if (pendingNavigation?.bar === bar) {
          if (Math.abs(window.scrollY - pendingNavigation.top) > 3 && Date.now() < pendingNavigation.until) return;
          pendingNavigation = null;
        }
        const threshold = bottom + bar.getBoundingClientRect().height + 30;
        const links = bar.querySelectorAll('a[data-holiday-sale-nav-item][href^="#"]');
        let selected = links[0];
        links.forEach(link => {
          const target = document.getElementById(link.getAttribute('href').slice(1));
          if (target && target.getBoundingClientRect().top <= threshold + 3) selected = link;
        });
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 3) selected = links[links.length - 1] || selected;
        if (selected && !selected.closest('.holiday-sale-navigation__item').classList.contains('is-active')) activate(bar, selected);
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('wheel', () => { pendingNavigation = null; }, { passive: true });
    window.addEventListener('touchstart', () => { pendingNavigation = null; }, { passive: true });
    window.addEventListener('keydown', () => { pendingNavigation = null; });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('click', event => {
      const selected = event.target.closest('[data-holiday-sale-nav-item]');
      if (!selected) return;
      const bar = selected.closest('[data-holiday-sale-navigation-bar]');
      if (!bar) return;
      if (selected.tagName === 'A') {
        const hash = selected.getAttribute('href');
        const target = hash?.startsWith('#') ? document.getElementById(hash.slice(1)) : null;
        if (target) {
          event.preventDefault();
          const offset = headerBottom() + bar.getBoundingClientRect().height + 24;
          const maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
          const top = Math.min(maxTop, Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset));
          pendingNavigation = { bar, top, until: Date.now() + 2500 };
          window.history.pushState(null, '', hash);
          window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
      activate(bar, selected);
    });
    schedule();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-poster-carousel"] && !Shopify.designMode) return;
  try {
    
  function initHolidayPosters(root) {
    if (root.dataset.holidayReady === 'true') return;
    root.dataset.holidayReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-holiday-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-holiday-dot]'));
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const interval = Number(root.dataset.interval) || 5000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    }
    function stop() { window.clearInterval(timer); timer = undefined; }
    function start() {
      stop();
      if (root.dataset.autoplay === 'true' && !reducedMotion.matches && !document.hidden) {
        timer = window.setInterval(() => show(current + 1), interval);
      }
    }
    root.querySelector('[data-holiday-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    root.querySelector('[data-holiday-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', start);
    start();
  }
  document.querySelectorAll('[data-holiday-poster]').forEach(initHolidayPosters);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holiday-poster]').forEach(initHolidayPosters));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-holiday-guarantee-open]');
    if (open) {
      const section = open.closest('[data-holiday-products]');
      section?.querySelector('[data-holiday-guarantee-dialog]')?.showModal();
      return;
    }
    const close = event.target.closest('[data-holiday-guarantee-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const variant = event.target.closest('[data-holiday-variant]');
    if (variant) {
      const product = variant.closest('[data-holiday-product]');
      product.querySelectorAll('[data-holiday-variant]').forEach(button => {
        const selected = button === variant;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      product.querySelector('[data-holiday-variant-id]').value = variant.dataset.variantId;
      product.querySelector('[data-holiday-price]').textContent = variant.dataset.price;
      const compare = product.querySelector('[data-holiday-compare]');
      const savings = product.querySelector('[data-holiday-savings]');
      compare.textContent = variant.dataset.compare || '';
      compare.hidden = !variant.dataset.compare;
      savings.textContent = variant.dataset.savings || '';
      savings.hidden = !variant.dataset.savings;
      return;
    }
    const galleryButton = event.target.closest('[data-holiday-prev], [data-holiday-next], [data-holiday-dot]');
    if (!galleryButton) return;
    const gallery = galleryButton.closest('[data-holiday-gallery]');
    const slides = [...gallery.querySelectorAll('[data-holiday-slide]')];
    const dots = [...gallery.querySelectorAll('[data-holiday-dot]')];
    if (!slides.length) return;
    const current = slides.findIndex(slide => slide.classList.contains('is-active'));
    const target = galleryButton.hasAttribute('data-holiday-prev') ? (current - 1 + slides.length) % slides.length : galleryButton.hasAttribute('data-holiday-next') ? (current + 1) % slides.length : Number(galleryButton.dataset.holidayDot);
    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === target);
      slide.setAttribute('aria-hidden', String(index !== target));
    });
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === target);
      dot.setAttribute('aria-current', String(index === target));
    });
  });
  document.addEventListener('click', event => {
    if (event.target.matches('[data-holiday-guarantee-dialog]')) event.target.close();
  });
  (() => {
    const startDay = Date.UTC(2026, 9, 30) / 86400000;

    function updateGiftBalances(root) {
      const days = Math.max(0, Math.floor(Date.now() / 86400000) - startDay);
      root.querySelectorAll('[data-holiday-gift-base]').forEach(card => {
        const base = Number(card.dataset.holidayGiftBase);
        if (!Number.isFinite(base)) return;
        const remaining = Math.max(0, base * Math.pow(0.99, days));
        const display = days === 0 ? String(base) : remaining.toFixed(1);
        const track = card.querySelector('.canta-gift-card__track');
        const fill = card.querySelector('.canta-gift-card__fill');
        const number = card.querySelector('.canta-gift-card__remaining strong');
        if (track) track.setAttribute('aria-valuenow', display);
        if (fill) fill.style.width = display + '%';
        if (number) number.textContent = display + '%';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateGiftBalances(document), { once: true });
    } else {
      updateGiftBalances(document);
    }
    document.addEventListener('shopify:section:load', event => updateGiftBalances(event.target));
    window.setInterval(() => updateGiftBalances(document), 60000);
  })();

  } catch(e) { console.error(e); }
})();
})();
